import { m, type MithrilVNode } from '../mithril';
import { Services } from '../services';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const LogoutPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.logout,
	path: '/logout',
	auth: { required: false },
	layout: { nav: false, banner: false },
};

export class LogoutPage extends IkePage {
	constructor() {
		super(LogoutPageConfig);
	}

	get nodes(): MithrilVNode {
		return m('div', { onupdate: () => Services.User.logout(), oncreate: () => Services.User.logout() });
	}
}
